import { render, staticRenderFns } from "./recordViewContent.vue?vue&type=template&id=03df4ff3&scoped=true&"
import script from "./recordViewContent.vue?vue&type=script&lang=ts&"
export * from "./recordViewContent.vue?vue&type=script&lang=ts&"
import style0 from "./recordViewContent.vue?vue&type=style&index=0&id=03df4ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df4ff3",
  null
  
)

export default component.exports